import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { searched } from "../../features/filter/filterSlice";

export default function Navbar() {
	const { searchText } = useSelector((state) => state.filter);
	const [search, setSearch] = useState(searchText);
	const dispatch = useDispatch();

	const handleSearch = (value) => {
		setSearch(value);
		dispatch(searched(value));
	};

	return (
		<nav className="container relative py-3">
			<div className="flex items-center justify-between">
				<Link to="/">
					<img src="/images/logo.svg" alt="lws logo" />
				</Link>
				<div className="flex-1 max-w-xs search-field group">
					<i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
					<input
						value={search}
						onChange={(e) => handleSearch(e.target.value)}
						type="text"
						placeholder="Search Task"
						className="search-input"
						id="lws-searchTask"
					/>
				</div>
			</div>
		</nav>
	);
}
